module.exports = __webpack_public_path__ + "img/LogoFooterWhite.869de484.svg";